import React from 'react';
import HighlightedTextComponent, { type HighlightedTextComponentProps } from 'content/HighlightedText';

interface HighlightedTextBlockProps {
    data: HighlightedTextComponentProps;
}

const HighlightedTextBlock: React.FC<HighlightedTextBlockProps> = (data) => {
    const { data: blockData } = data;
    return <HighlightedTextComponent {...blockData} />;
};
export default HighlightedTextBlock;
